// src/pages/About.tsx

import React, {ReactElement, FC} from "react";
import {Box, Typography} from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import {useNavigate} from "react-router-dom";
import { useGlobalState } from '../state';

const Config: FC<any> = (): ReactElement => {

    let navigate = useNavigate();

    let [data, update] = useGlobalState('data');

    // if (data.mesh_form_unrendered) {
    //     let painted_temp = data.painted;
    //     let mesh_form_unrendered = false;
    //     update((p) => ({ ...p, painted_temp }));
    //     update((p) => ({ ...p, mesh_form_unrendered }));
    // }

    const handleRadioClick = (painted_temp: boolean) => {

        console.log('toggle painted',painted_temp);

        update((p) => ({ ...p, painted_temp }));
    }

    const handleCheckOption = (e: any, i: number) => {
        console.log('handleCheckOption',i);
        let mesh_options_temp = data.mesh_options_temp;
        if (e.target.checked) {
            console.log('checked');
            mesh_options_temp = mesh_options_temp.substring(0, i) + 't' + mesh_options_temp.substring(i + 1);
        } else {
            console.log('unchecked');
            mesh_options_temp = mesh_options_temp.substring(0, i) + 'f' + mesh_options_temp.substring(i + 1);
        }

        console.log(mesh_options_temp);
        update((p) => ({ ...p, mesh_options_temp }));
    }

    const handleCheckAll = (e: any) => {
        console.log('handleCheckAll');
        let mesh_options_temp = data.mesh_options_temp;
        if (e.target.checked) {
            console.log('checked');
            mesh_options_temp = 'ttttttt';
        } else {
            console.log('unchecked');
            mesh_options_temp = 'fffffff';
        }
        console.log(mesh_options_temp);
        update((p) => ({ ...p, mesh_options_temp }));
    }

    const handleCancel = () => {
        let painted_temp = data.painted;
        let mesh_options_temp = data.mesh_options;

        update((p) => ({ ...p, painted_temp }));
        update((p) => ({ ...p, mesh_options_temp }));
        navigate('/3d');
    }

    const handleSave = () => {
        let painted = data.painted_temp;
        let mesh_options = data.mesh_options_temp;
        let redisplay = true;

        update((p) => ({ ...p, painted }));
        update((p) => ({ ...p, mesh_options }));
        update((p) => ({ ...p, redisplay }));
        navigate('/3d');        
    }
    
    return (
        <Box sx={{
            flexGrow: 1,
            backgroundColor: 'whitesmoke',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start'
        }}>
            {/*<Typography variant="h3">About</Typography>
            <StrictMode>
                <h1>Person</h1>
                <Person />
                <Person />
            </StrictMode> */}
            <Grid container>
            <Grid item style={{height: '10px'}} xs={12}/>
            <Grid item xs={1} />
                <Grid item xs={11}>
                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">
                            <Typography color="black" variant="h5">
                                Mesh options
                            </Typography>
                        </FormLabel>
                    </FormControl>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={11}>
                    <FormControl>
                    <div>
                        <FormGroup style={{marginLeft: '50px'}}>
                            <FormControlLabel control={<Checkbox id="low" checked={data.mesh_options_temp[0] === 't'} onClick={(e) => {handleCheckOption(e,0);}}/>} label="Low density OB stars" />
                            <FormControlLabel control={<Checkbox id="dust" checked={data.mesh_options_temp[1] === 't'} onClick={(e) => {handleCheckOption(e,1);}}/>} label="Dust" />
                        </FormGroup>
                    </div>                        
                    </FormControl>
                </Grid>
                <Grid item style={{height: '10px'}} xs={12}/>
                <Grid item xs={1}/>
                <Grid item xs={11}>
                    <Button onClick={handleCancel} style={{marginRight:'20px'}} variant="outlined" color="error">Cancel</Button>
                    <Button onClick={handleSave} variant="contained" color="primary">Save</Button>                    
                </Grid>
            </Grid>
        </Box>
    );
};

export default Config;